import {Lote} from "@/models/sie-pedidos/lote";
interface HeaderItemTableLotes {
  text: string;
  align: string;
  sortable: Boolean;
  value: String;
}

export interface PaginationTableLotes{
  id: Number;
  graficaId: number;
  numeroLote: string;
  entidadeId: number;
  situacao: number;
  dataInicio?: string;
  dataFim?: string;
  page: number;
  size: number;
  sortBy: string,
  sortOrder: string
}


export interface TableLotes {
  dadosFilterLotes: DadosFilterLotes;
  header: HeaderItemTableLotes[];
  content: Lote[];
  paginate: PaginationTableLotes;
  isLoading: Boolean;
  total: Number;
}

const header: HeaderItemTableLotes[] = [
  {
    text: 'Gráfica',
    align: 'start',
    sortable: true,
    value: 'graficaNomeFantasia'
  },
  {
    text: "Número do Lote",
    align: "start",
    sortable: true,
    value: "id"
  },
  {
    text: "Entidade",
    align: "start",
    sortable: true,
    value: "entidadeSigla"
  },
  {
    text: "Status",
    align: "start",
    sortable: true,
    value: "situacao"
  },
  {
    text: "Data",
    align: "start",
    sortable: true,
    value: "createdDate"
  },
  {
    text: "Ações",
    align: "start",
    sortable: false,
    value: "acoes"
  }
]

const content: Lote[] = []

const paginate: PaginationTableLotes = {
  id: null,
  numeroLote: null,
  graficaId: null,
  entidadeId: null,
  situacao: null,
  dataInicio: null,
  dataFim: null,
  page: 0,
  size: 10,
  sortBy: "id",
  sortOrder: "ASC"
}

export interface ModelDados {
  id: Number;
  descricao: string
}

export interface DadosFilterLotes {
  listSituacao: ModelDados[];
  listEntidade: ModelDados[];
}

const dadosFilterLotes: DadosFilterLotes = {
  listSituacao: [],
  listEntidade: []
}

const tableLotes: TableLotes = {
    dadosFilterLotes,
    header,
    content,
    paginate,
    isLoading: false,
    total: 0
}

export  default tableLotes
